import alerts from './alerts'

export default { alerts }
